const subscription = {
  subscribe: "Abonnieren",
  demoState: "Demo",
  ongoingState: "Abonnent",
  expiryState: "Abgelaufen",
  resubscribe: "Erneut abonnieren",
  extendSubscribe: "Mein Abonnement verlängern bis:",
  status: "Status:",
  endsubscription: "Ablauf des Abonnements:",
  expiryDate: "Ablaufdatum:",
  subscribeTitle: "Inhalt des Angebots",
  subscribeContent:
    "Dieses Angebot beinhaltet einen uneingeschränkten Zugang zu allen Übungen und Arbeitsblättern für die Niveaus A1, A2, B1 und B2 für die Dauer von 1 Jahr.",
  subscribePrice: "Der Preis für das Abonnement beträgt",
  expiryDateReminder: "Ihr Abonnement endet am",
  renewalProposal:
    "Um weiterhin von iizenglish zu profitieren, verlängern Sie Ihr Abonnement!",
  renewalOk: "Ok",
  renewalDisable: "Nicht mehr anzeigen",
  renewalAccept: "Erneut abonnieren",
  resubscribeExtendDate: "Mein Abonnement wird verlängert bis :",
  remiderSubscriptionModalTitle: "Jetzt abonnieren!",
  mySubscription: "Mein Abonnement",
  subscription: "Abonnement",
};

export default subscription;
